// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SubStepWrapper__wrapper","card":"SubStepWrapper__card","imageCol":"SubStepWrapper__imageCol","imageCard":"SubStepWrapper__imageCard","cardHeader":"SubStepWrapper__cardHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubStepWrapper/SubStepWrapper.scss
// module id = ./src/components/SubStepWrapper/SubStepWrapper.scss
// module chunks = 2